import { useCallback, useEffect, useState } from 'react';
import { publicReportPrivacyApi, PrivacyPolicyInput } from '../../api/publicReportPrivacyApi';
import { PublicReportPrivacyPolicy } from '../../types/publicReport';

/**
 * The instance's privacy policy for public QR codes, with save and clear.
 * Both actions throw a Swedish message on failure, for the caller to show.
 */
export const usePublicReportPrivacy = () => {
    const [policy, setPolicy] = useState<PublicReportPrivacyPolicy | null>(null);
    const [loading, setLoading] = useState(true);
    const [loadError, setLoadError] = useState<string | null>(null);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        let cancelled = false;
        publicReportPrivacyApi.getPolicy()
            .then(result => { if (!cancelled) setPolicy(result); })
            .catch(error => {
                console.error('Error loading privacy policy:', error);
                if (!cancelled) setLoadError('Kunde inte ladda integritetspolicyn');
            })
            .finally(() => { if (!cancelled) setLoading(false); });
        return () => { cancelled = true; };
    }, []);

    const save = useCallback(async (input: PrivacyPolicyInput) => {
        setSaving(true);
        try {
            setPolicy(await publicReportPrivacyApi.savePolicy(input));
        } finally {
            setSaving(false);
        }
    }, []);

    const clear = useCallback(async () => {
        setSaving(true);
        try {
            await publicReportPrivacyApi.clearPolicy();
            setPolicy(null);
        } finally {
            setSaving(false);
        }
    }, []);

    return { policy, loading, loadError, saving, save, clear };
};
